import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import { isLicenseKeyValid } from '../common/keyValidation';
import OverlayLoader from '../components/overlayLoader';
import * as webViewerServersActions from '../store/webViewerServersSlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import { showModalMessage } from '../store/modalsSlice';

import LicenseKeyInputNormalized from '../components/licenseKeyInputNormalized';
import { unwrapResult } from '@reduxjs/toolkit';

class AssignLWebViewerServerToClientDialog extends Component {
  initState = {
    serverKey: '',
    loadedServer: null,
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onClose = this.onClose.bind(this);
    this.onKeyChanged = this.onKeyChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onKeyChanged(normalizedLicenseKey) {
    this.setState({ serverKey: normalizedLicenseKey }, this.loadWebViewerServerInfo);
  }

  loadWebViewerServerInfo() {
    if (this.isCorrectServerKey()) {
      this.props.getWebViewerServerByKey({ serverKey: this.state.serverKey.trim() })
        .then(unwrapResult)
        .then((server) => {
          this.setState({ loadedServer: server });
        })
    }
  }

  isLoading() {
    return this.props.isWebViewerServerLoading;
  }

  getLoaderMessage() {
    if (this.props.isWebViewerServerLoading) {
      return "Web viewer server loading...";
    }
  }

  isSubmitButtonDisabled() {
    return this.isLoading() ||
      !this.isCorrectServerKey() ||
      this.state.loadedServer === null ||
      (this.state.loadedServer.client !== null &&
        this.state.loadedServer.client.id === this.props.clientId);
  }

  isCorrectServerKey() {
    return isLicenseKeyValid(this.state.serverKey.trim());
  }

  onSubmit() {
    this.onClose();
    this.props.assignWebViewerServerToClient({
        serverId: this.state.loadedServer.id, clientId: this.props.clientId
      }
    )
      .then(unwrapResult)
      .catch(() => {
        const error = this.props.assignmentError;
        this.props.showModalMessage("Error", error && error.toString())
      });
  }

  renderStatic() {
    return [
      <FormGroup controlId="fcClientName" key="fcClientNameAssign">
        <ControlLabel>Client name</ControlLabel>
        <FormControl.Static>{this.props.clientName}</FormControl.Static>
      </FormGroup>,
      <FormGroup controlId="fcServerKey" key="fcServerKeyAssign">
        <ControlLabel>Server key</ControlLabel>
        <LicenseKeyInputNormalized onChange={this.onKeyChanged} />
      </FormGroup>
    ];
  }

  renderServerKeyError() {
    let message = this.state.serverKey.length === 0 ? {
      text: "Enter server key",
      className: "text-info"
    } : {
      text: "Server key is not correct",
      className: "text-danger"
    };
    return <FormControl.Static className={message.className}>{message.text}</FormControl.Static>;
  }

  renderDynamic() {
    return !this.isCorrectServerKey() ?
      this.renderServerKeyError() :
      this.renderLoadingResults();
  }

  renderLoadingResults() {
    if (this.state.loadedServer === null) {
      if (this.props.isWebViewerServerLoading)
        return null;
      return <FormControl.Static className="text-danger">Web viewer server is not found</FormControl.Static>;
    }
    let client = this.state.loadedServer.client;
    if (client !== null && client.id === this.props.clientId)
      return (
        <FormControl.Static className="text-danger">
          Web viewer server is already assigned to this client
        </FormControl.Static>
      );
    return [
      client === null || client.id === null ? null :
        <FormControl.Static className="text-warning">
          Web viewer server is already assigned to client named <strong>{client.fullName}</strong>
        </FormControl.Static>,
      this.renderWebViewerServerInfo()
    ];
  }

  renderWebViewerServerInfo() {
    let server = this.state.loadedServer;
    return [
      <FormGroup controlId="fcProductName">
        <ControlLabel>Product name</ControlLabel>
        <FormControl.Static>{server.productName}</FormControl.Static>
      </FormGroup>,
      <FormGroup controlId="fcGenDate">
        <ControlLabel>Generation date and time</ControlLabel>
        <FormControl.Static>{server.generationDateTime}</FormControl.Static>
      </FormGroup>,
      <FormGroup controlId="fcActivDate">
        <ControlLabel>Activation date and time</ControlLabel>
        <FormControl.Static>{server.activationDateTime}</FormControl.Static>
      </FormGroup>
    ];
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>Assign web viewer server to client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
            {this.renderStatic()}
            {this.renderDynamic()}
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            Assign
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
};

const mapStateToProps = (state) => ({
  isWebViewerServerLoading: webViewerServersSelectors.state(state).isFetching,
  webViewerServerLoadingError: webViewerServersSelectors.state(state).fetchingError,
  assignmentError: webViewerServersSelectors.state(state).assignmentError,
});

const actionCreators = {
  getWebViewerServerByKey: webViewerServersActions.fetchByKey,
  assignWebViewerServerToClient: webViewerServersActions.assignToClient,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
}

export default connect(mapStateToProps, actionCreators)(AssignLWebViewerServerToClientDialog);


// WEBPACK FOOTER //
// ./src/containers/assignWebViewerServerToClientDialog.js